import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router';

import { OperatorType } from '@/api/enums/Operators.ts';
import { GoodTariffsDataResponse, GoodTariffsResListItem } from '@/api/types';
import { TariffCard } from '@/components/AllNumbers/TariffsList/TariffCard/TariffCard.tsx';
import { FireIcon } from '@/components/icons/main-block';
import { Button } from '@/components/shared/Button';
import { appRoutes } from '@/routes/app-routes.ts';
import { ChosenNumber } from '@/types';
import { getCorrectMultipleWord, getEnumKeyByValue } from '@/utils';

import cn from './styles.module.sass';

interface ITariffsListProps {
    list?: GoodTariffsResListItem[];
    onClick: (chosenNumber: Partial<ChosenNumber>) => void;
    foundAmount?: number;
    isLoading?: boolean;
    tariffsData?: GoodTariffsDataResponse['data'];
}

export const TariffsList = ({
    list,
    onClick,
    foundAmount = 0,
    isLoading,
    tariffsData,
}: ITariffsListProps) => {
    return (
        <div className={cn.tariffsListContainer}>
            {list?.length === 0 ? (
                <div className={cn.noTariffs}>
                    <div className={cn.iconContainer}>{FireIcon}</div>
                    <div className={cn.noTariffsText}>Скоро тут появятся выгодные тарифы</div>
                    <Link className={cn.link} to={appRoutes.mainPage}>
                        <Button>Выбрать номера</Button>
                    </Link>
                </div>
            ) : (
                <>
                    <div className={cn.foundAmount}>
                        Найдено: {foundAmount} {getCorrectMultipleWord('тариф', foundAmount)}
                    </div>
                    <div className={cn.tariffsList}>
                        {isLoading ? (
                            <Skeleton
                                height={58}
                                count={5}
                                containerClassName={cn.tariffsSkeletonContainer}
                            />
                        ) : (
                            list?.map(tariff => {
                                const minutes = tariff.tariff.minutesAmount
                                    ? `${tariff.tariff.minutesAmount} мин`
                                    : '';
                                const traffic = tariff.tariff.trafficAmount
                                    ? `, ${tariff.tariff.trafficAmount}`
                                    : '';
                                const sms = tariff.tariff.smsAmount
                                    ? `, ${tariff.tariff.smsAmount} смс`
                                    : '';
                                const description = minutes + traffic + sms;
                                const price = tariff.tariff.privatePrice + ' ₽';
                                const deviceTypeObj = tariffsData?.deviceTypes.find(
                                    item => item.id === tariff.tariff.deviceType
                                );

                                const tariffName = tariff.tariff.privateName || tariff.tariff.name;

                                const chosenObj: Partial<Omit<ChosenNumber, 'number' | 'region'>> =
                                    {
                                        operator:
                                            getEnumKeyByValue(
                                                OperatorType,
                                                tariff.tariff.operatorId
                                            ) || '',
                                        tariff: tariff.tariff.name,
                                        price: tariff.tariff.publicPrice,
                                        tariffMin: tariff.tariff.minutesAmount,
                                        tariffInternet: tariff.tariff.trafficAmount,
                                        tariffSms: tariff.tariff.smsAmount,
                                        deviceType: deviceTypeObj?.name || '',
                                    };

                                return (
                                    <TariffCard
                                        key={tariff.tariff.sid}
                                        title={tariffName.replaceAll('&infin;', '∞')}
                                        description={description}
                                        price={price}
                                        deviceType={deviceTypeObj?.name}
                                        numbers={tariff.numbers}
                                        options={tariff.tariff.options}
                                        tariffOptions={tariffsData?.tariffOptions}
                                        onClick={onClick}
                                        chosenObj={chosenObj}
                                        tariffId={tariff.tariff.sid}
                                        tariffsList={tariffsData?.list}
                                        showLoadMore={list?.length >= tariff.count}
                                    />
                                );
                            })
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
